import { Oval } from "react-loader-spinner";
import VeilighDarkIcon from "~/assets/logos/veiligh_black_icon.png";

const PageLoader = () => {
  return (
    <div className="relative flex min-h-svh flex-col items-center justify-center bg-white">
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        <img src={VeilighDarkIcon} alt="logo" className="h-12 w-12" />
      </div>
      <Oval
        height="120"
        width="120"
        strokeWidthSecondary={4}
        color="#CBFF10"
        secondaryColor="#D9D9D9"
        ariaLabel="oval-loading"
        strokeWidth={4}
      />
    </div>
  );
};

export default PageLoader;
